import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Stroke: React.FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 9 42.5" fill="#fff" preserveAspectRatio="none" shapeRendering="crispEdges" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M0.5 42V0H9.5V42H0.5Z" fill="white" />
    <path fillRule="evenodd" clipRule="evenodd" d="M3 42.125V0H7V42.125H3Z" fill="#000000" />
  </SvgIcon>
);
